import { capture } from "./capture";

export const IncidentsTracking = {
  /** Incident detail page viewed. */
  detailViewed: (incidentId: string) => {
    capture("incidents.detail_viewed", { incident_id: incidentId });
  },

  /** Incidents searched. */
  searched: (query: string) => {
    capture("incidents.searched", { query });
  },
};
